import { render, staticRenderFns } from "./chair.vue?vue&type=template&id=5527e4b5&scoped=true"
import script from "./chair.vue?vue&type=script&lang=js"
export * from "./chair.vue?vue&type=script&lang=js"
import style0 from "./chair.vue?vue&type=style&index=0&id=5527e4b5&prod&lang=css"
import style1 from "./chair.vue?vue&type=style&index=1&id=5527e4b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527e4b5",
  null
  
)

export default component.exports